import { downloadTexts } from '@constants/general'

export const texts = {
  de: {
    source: 'Quelle: BSW',
    asOf: 'Stand',
    titleCurrent: 'Aktueller Trend des Monats',
    titlePrevious: 'Vorheriger Trend des Monats',
    endResults: 'Endergebnis der Umfrage',
    interimResults: 'Zwischenergebnis der Umfrage',
    participants: 'Teilnehmer',
    errorToastTitle: 'Information',
    errorToastBody: 'Bitte eine Antwortmöglichkeit auswählen',
    submit: 'Senden',
    noData: 'Keine Daten verfügbar',
    download: downloadTexts.de
  },
  en: {
    source: 'Source: BSW',
    asOf: 'As at',
    titleCurrent: 'Current Trend of the Month',
    titlePrevious: 'Previous Trend of the Month',
    endResults: 'Final results of the survey',
    interimResults: 'Interim results of the survey',
    participants: 'participants',
    errorToastTitle: 'Information',
    errorToastBody: 'Please select an answer option',
    submit: 'Submit',
    noData: 'No data available',
    download: downloadTexts.en
  }
}
